import type { Theme } from '@/api/types';

export const THEMES: Theme[] = [
  'default',
  'bachelorette',
  'birthday',
  'retro',
  'christmas',
  'minimal',
];

export function applyTheme(theme: Theme | undefined) {
  document.documentElement.dataset.theme = theme ?? 'default';
}

export const THEME_LABELS: Record<Theme, string> = {
  default: 'Default — cream & tomato',
  bachelorette: 'Bachelorette — pink & gold',
  birthday: 'Birthday — punch & balloon',
  retro: 'Retro — burnt orange & forest',
  christmas: 'Christmas — red & evergreen',
  minimal: 'Minimal — ink & paper',
};
